import React from 'react';
import './GalleryPage.css';

function GalleryPage() {
  return (
    <div className="gallery-page">
      <section className="gallery-hero">
        <div className="container">
          <h1>GALLERY</h1>
          <p>Memories from CISAC General Assembly 2026</p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="gallery-placeholder">
            <div className="placeholder-icon">📸</div>
            <h2>Gallery Coming Soon</h2>
            <p>
              Photos from the CISAC General Assembly 2026 will be available here
              after the event concludes.
            </p>
            <p className="gallery-note">
              Official event photos will be shared on our Flickr gallery.
              Check back after June 4, 2026 for updates.
            </p>
            <div className="placeholder-features">
              <div className="feature-item">
                <div className="feature-icon">🎥</div>
                <h3>Event Highlights</h3>
                <p>Professional photos from the General Assembly</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🤝</div>
                <h3>Networking Moments</h3>
                <p>Candid shots from meetings and social events</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🏛️</div>
                <h3>Venue & Paris</h3>
                <p>Beautiful shots of Pavillon Cambon and Paris</p>
              </div>
            </div>
          </div>

          <div className="gallery-contact">
            <h3>Stay Updated</h3>
            <p>
              For questions about the photo gallery or to share your own photos,
              please contact:
            </p>
            <p className="contact-email">
              <a href="mailto:2026ga@cisac.org">2026ga@cisac.org</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default GalleryPage;
